// eslint-disable-next-line @typescript-eslint/no-require-imports
const { createI18n } = require("vue-i18n/dist/vue-i18n.cjs");
import getEnv from "./env";

import fr from "./locales/fr.json";

const env = getEnv();

export const i18n = createI18n({
    locale: env.VUE_APP_I18N_LOCALE || "fr",
    fallbackLocale: env.VUE_APP_I18N_FALLBACK_LOCALE || "fr",
    allowComposition: true,
    messages: {
        fr,
    },
});
